import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { Button } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import { StyledContainer, StyledLoadMoreContainer } from '../index.css'

const StyledButton = styled(Button).attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.loadMore
})`
  width: 99px;
  height: 32px;
  position: absolute;
  left: -50%;
  white-space: nowrap;
`

type LoadMoreButtonProps = {
  callback: () => void
}

const LoadMoreButton = ({ callback }: LoadMoreButtonProps) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  return (
    <StyledContainer mode={theme}>
      <StyledLoadMoreContainer>
        <StyledButton mode={theme} color="secondary" onClick={callback}>
          {t('loadMore')}
        </StyledButton>
      </StyledLoadMoreContainer>
    </StyledContainer>
  )
}

export default LoadMoreButton
